/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_Q8_AnswerInputs */

const en_home_faq_q8_answer = /** @type {(inputs: Home_Faq_Q8_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Reset Password from the login page or contact support if you need assistance accessing your account.`)
};

const fr_home_faq_q8_answer = /** @type {(inputs: Home_Faq_Q8_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez « Réinitialiser le mot de passe » depuis la page de connexion ou contactez le soutien si vous avez besoin d'aide pour accéder à votre compte.`)
};

/**
* | output |
* | --- |
* | "Use Reset Password from the login page or contact support if you need assistance accessing your account." |
*
* @param {Home_Faq_Q8_AnswerInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_faq_q8_answer = /** @type {((inputs?: Home_Faq_Q8_AnswerInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_Q8_AnswerInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_faq_q8_answer(inputs)
	return fr_home_faq_q8_answer(inputs)
});